angular.module('mercury.modules.qa.wizbang')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.QaWizbangPeriodEndReport', {
    controller: 'QaWizbangPeriodendCtrl',
    url: '/qa/wizbang/periodend?report',
    templateUrl: 'modules/qa/wizbang/periodend/periodend.tpl.html'
  });

  $stateProvider.state('Reports.QaWizbangSaleCategoryReport', {
    controller: 'QaWizbangSaleCategoryCtrl',
    url: '/qa/wizbang/salecategory?report',
    templateUrl: 'modules/qa/wizbang/salecategory.tpl.html'
  });

  $stateProvider.state('Reports.QaWizbangOrdersReport', {
    controller: 'QaWizbangOrdersCtrl',
    url: '/qa/wizbang/orders?report',
    templateUrl: 'modules/qa/wizbang/orders.tpl.html'
  });

  $stateProvider.state('Reports.QaWizbangTransactionsReport', {
    controller: 'QaWizbangTransactionsCtrl',
    url: '/qa/wizbang/transactionlistingreportOutletLine?report',
    templateUrl: 'modules/qa/wizbang/transactionlisting.tpl.html'
  });

  $stateProvider.state('Reports.QaWizbangVoidsReport', {
    controller: 'QaWizbangVoidsCtrl',
    url: '/qa/wizbang/voids?report',
    templateUrl: 'modules/qa/wizbang/voids.tpl.html'
  });
}]);
